
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/employers-news/[url_slug]",
      function () {
        return require("private-next-pages/employers-news/[url_slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/employers-news/[url_slug]"])
      });
    }
  